/**
 * iter-67 — Single source of truth for character avatar/badge text.
 *
 * Rule (locked by the user):
 *   • If the character has a `character_number`, that number IS the
 *     avatar — it takes precedence over the initial letter everywhere.
 *   • Otherwise we fall back to the first letter of the name (uppercase).
 *
 * Used by Cast list, Character detail header, Scene character cards,
 * Fittings cast views, Assignment search results, etc.
 */
export function characterAvatar(character) {
    if (!character) return "?";
    const num = (character.character_number ?? "").toString().trim();
    if (num) return num;
    const name = (character.name || "").trim();
    if (!name) return "?";
    return name.slice(0, 1).toUpperCase();
}
